import React from 'react'

export function WelcomePopup({ deviceName, icon, onClose, debugInfo }) {
  return (
    <div
      className="welcome-popup-overlay"
      onClick={onClose}
      onKeyDown={e => e.key === 'Escape' && onClose()}
      role="dialog"
      aria-label={debugInfo ? 'Device detection' : 'Welcome'}
      tabIndex={0}
    >
      <div
        className={`welcome-popup ${debugInfo ? 'welcome-popup-debug' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        <span className="welcome-popup-icon" aria-hidden>
          {icon}
        </span>
        <p className="welcome-popup-title">{debugInfo ? 'Detect device' : 'Welcome'}</p>
        <p className="welcome-popup-device">{deviceName}</p>
        {debugInfo && (
          <div className="welcome-popup-debug-info">
            <dl className="welcome-popup-debug-dl">
              <dt>isWearOSDevice</dt>
              <dd>{String(debugInfo.isWearOSDevice)}</dd>
              <dt>isTinyWatchScreen</dt>
              <dd>{String(debugInfo.isTinyWatchScreen)}</dd>
              <dt>isSmallWatchLikeScreen</dt>
              <dd>{String(debugInfo.isSmallWatchLikeScreen)}</dd>
              <dt>screen (width × height)</dt>
              <dd>{debugInfo.screenWidth != null && debugInfo.screenHeight != null ? `${debugInfo.screenWidth} × ${debugInfo.screenHeight}` : '—'}</dd>
              <dt>avail (width × height)</dt>
              <dd>{debugInfo.availWidth != null && debugInfo.availHeight != null ? `${debugInfo.availWidth} × ${debugInfo.availHeight}` : '—'}</dd>
              <dt>outer (width × height)</dt>
              <dd>{debugInfo.outerWidth != null && debugInfo.outerHeight != null ? `${debugInfo.outerWidth} × ${debugInfo.outerHeight}` : '—'}</dd>
              <dt>inner (width × height)</dt>
              <dd>{debugInfo.innerWidth != null && debugInfo.innerHeight != null ? `${debugInfo.innerWidth} × ${debugInfo.innerHeight}` : '—'}</dd>
              <dt>matchMedia (max-width: 300px)</dt>
              <dd>{debugInfo.matchMediaMaxWidth300px === null ? '—' : String(debugInfo.matchMediaMaxWidth300px)}</dd>
            </dl>
            <p className="welcome-popup-debug-ua-label">User-Agent</p>
            <pre className="welcome-popup-debug-ua">{debugInfo.userAgent || '—'}</pre>
            <p className="welcome-popup-hint">Tap outside to close</p>
          </div>
        )}
        {!debugInfo && <p className="welcome-popup-hint">Tap to close</p>}
      </div>
    </div>
  )
}
